"use strict";

(function (global) {
 
  /**
   * Навешивает меню на кнопку "Выполнить" для заданий.
   *
   * @function Core.toolBars.job.initPerformButton
   * @param {WebAccess.components.wrappers.toolBar.ToolBarButton} button Кнопка "Выполнить" на ленте тулбара.   
   * @since 5.2.0.1500
   */
  global.initPerformButton = function (button) {        
    $.when(Core.jobs.performResults.performResultsInit).done(() => {
      const choices = Core.jobs.performResults.getAll();    
      
      var menu_items = [];
      for (var i = 0; i < choices.length; ++i) {
        menu_items.push({
          text: choices[i].DisplayName,
          onClick: (function (performResult) { // замыкание для корректной передачи choices[i], т.к. переменная i меняется в цикле
            return function () {
              global.performResult(performResult);
            };
          })(choices[i])
        });
      }
      var additionalSettings = {
        onShow: function () {
          button.select();
        },
        onHide: function () {
          button.unSelect();
        }
      };
      var menu = new ContextMenu(menu_items, {
        shiftX: 0,
        shiftY: 38,
        width: "auto",
        cssClass: "performs-context-menu",
        onShow: function () {
          if (!button.isEnabled()) {
            ContextMenu.hide();
            return false;
          }
          additionalSettings.onShow();
        },
        onHide: function () {
          additionalSettings.onHide();
        }
      });
      // Добавляем контекстное меню для кнопки. Добавление возможно только через jQuery элемент,
      // т.к. для контекстного меню используются функции jQuery.
      var jButton = $(format('div[name={0}]', button.name));
      jButton.contextMenu(menu);    
    });    
  };

  /**
   * Действие на кнопку "Выполнить" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.perform
   */
  global.perform = () => {
    const _checkAttachmentAccessRights = (callback) => {
      WA.SRV.call('Job.asmx/CheckAttachmentsRights', {
        JobId: WA.CR.ID,
      }).done((maxRights) => {
        const _setAccessRights = (accessRights) => {
          WA.SRV.call('Job.asmx/SetAttachmentsRights', {
            JobID: WA.CR.ID,
            Rights: accessRights,
          }).done(() => {
            callback();
          });
        };

        if (maxRights !== 'NoAccess') {
          Core.customWorks.showAccessRightsDialog(maxRights, {
            View: () => _setAccessRights(ACCESS_RIGHTS.VIEW),
            Change: () => _setAccessRights(ACCESS_RIGHTS.CHANGE),
            Full: () => _setAccessRights(ACCESS_RIGHTS.FULL),
            Ignore: () => callback(),
          }, L('WARN_ASSIGN_TASK_ATTACHMENTS_RIGHTS_DLG_MSG'));
        } else {
          callback();
        }
      });
    };

    if (!CheckIsWf()) {
      ConfirmDialogNew(L('CONFIRM_JOB_PERFORM'), () => {
        _checkAttachmentAccessRights(() => {
          Core.jobs.performJob(WA.CR.ID, 0);
        });
      });
    } else {
      if (!ResultNotEmpty()) {
        WebAccess.Job.fireAll('Perform', () => {
          // Нет результатов выполнения.
          _executeBeforeQueryParamsEvent('').done((result) => {
            if (result.hasAskableParams) {
              // Есть запрашиваемые параметры.
              _requestAskableParams();
            } else {
              // Нет запрашиваемых параметров.
              WebAccess.Job.fireAll('ParamAsking', () => {
                ConfirmDialogNew(L('CONFIRM_JOB_PERFORM'), () => {
                  _checkAttachmentAccessRights(() => {
                    Core.jobs.performJob(WA.CR.ID, 0);
                  });
                });
              });
            }
          });
        });
      }
    }
  };

  /**
   * Действие на кнопку "Выполнить с результатом выполнения" для заданий.
   * @param {object} performResult Вариант выполнения.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.performResult
   */
  global.performResult = (performResult) => {
    // Устанавить значение скрытого контрола с ИД __RESULT_VAR. Отсюда веб-модули берут индекс варианта выполнения.
    $('#__RESULT_VAR').val(performResult.Index);
    WebAccess.Job.fireAll('Perform', () => {
      _executeBeforeQueryParamsEvent(performResult.Name).done((res) => {
        if (res.hasAskableParams) {
          _requestAskableParams(performResult.Index);
        } else {
          ConfirmDialogNew(L('CONFIRM_JOB_PERFORM_RESULT', performResult.DisplayName), () => {
            WebAccess.Job.fireAll('ParamAsking', () => {
              Core.jobs.performJob(WA.CR.ID, performResult.Index);
            });
          });
        }
      });
    }, performResult);
  };

  /**
  * Действие на кнопку "Выполнить с результатом выполнения" для заданий по коду выполнения.
  * @param {string} performResultCode Код варианта выполнения.
  * @since 5.7.0
  * @function Core.toolBars.job.performByResultCode
  */
  global.performByResultCode = (performResultCode) => {
    const performResult = Core.jobs.performResults.getByCode(performResultCode);
    global.performResult(performResult);
  }

  /**
   * Действие на кнопку "Выполнить с результатом выполнения" для заданий.
   * @since 5.2.0.1500
   * @function Core.toolBars.job.performResultInMobile
   */
  global.performResultInMobile = (resultEl) => {
    global.performResult({
      Name: $(resultEl).text(),
      Index: resultEl.id
    });
  };
 
  /**
   * Действие на кнопку "Принять задание-контроль" для заданий.
   * @param {number} performResult Индекс результаты выполнения задания.
   * @since 5.7.0
   * @function Core.toolBars.job.acceptContolJob
   */ 
  global.acceptContolJob = (performResult) => {
    //выбран вариант с выполнением ведущего задания
    if (performResult === 1) {
      Core.jobs.performJob(WA.CR.ID, performResult, false).done(() => {
        WA.SRV.request('/Job.asmx/GetJobPerformResult', {
          JobID: WA.CR.LeaderJobID,
        }).success(performResults => {
          _showLeaderJobPerformDialog(JSON.parse(performResults));
        }).error(errorMessage => {
          WA.CR.inlineHint.showError(errorMessage);
        });
      });
    } else if (performResult === 3) {
      Core.jobs.performJob(WA.CR.ID, performResult, false).done(() => {
        // Откроем страницу с задачей по заданию на редактирование
        let url = new WA.URL();       
        url.setParam('ID', WA.CR.LeaderJobID);
        window.location.href = url.asString(); 
      });     
    } else {
      Core.jobs.performJob(WA.CR.ID, performResult);
    }
  };

  /**
  * Действие на кнопку "Отправить на доработку задание-контроль" для заданий.  
  * @since 5.7.0
  * @function Core.toolBars.job.resumeContolJob
  */ 
  global.resumeContolJob = () => {    
    WA.SRV.request('/Job.asmx/ResumeControlJob', {
      JobID: WA.CR.ID
    }).done(() => { 
      WA.CR.window.unbind('beforeClose');
      // Откроем страницу с задачей по заданию на редактирование
      let url = new WA.URL();
      url.setParam('ID', WA.CR.TaskID).setParam('mode', 'edit').setParam('View', 'Card');
      window.location.href = url.asString().replace('Job.aspx', 'Task.aspx').replace('job.aspx', 'Task.aspx');
    }).fail(errorMessage => {
      WA.CR.inlineHint.showError(errorMessage);          
    });      
  };
 
  /**
   * Выполняет событие "До запроса параметров".
   * @inner
   * @param {object} performResultCode Имя результата выполнения.
   * @param {number} jobID ИД задания.
   * @returns {Deferred} Deferred-объект.
   */
  const _executeBeforeQueryParamsEvent = (performResultCode, jobID = WA.CR.ID) => {
    let activeText;
    let jActiveText;
    if (jobID === WA.CR.ID) {
      jActiveText = WA.isMobile() ? $('.textarea'): $('.Job_Edit_Text_Area_Control').filter('textarea');     
      activeText = jActiveText.val();              
    } 
    const params = {    
      ActiveText: activeText || '',
      JobID: jobID,
      PerformResultName: performResultCode,      
    };
    return WA.SRV.call('/Job.asmx/ExecuteBeforeQueryParamsEvent', params).done((res) => {
      if (jActiveText) {
        jActiveText.val(res.newActiveText);
      }      
    });        
  };
  
  /**
  * Вызывает показ запрашиваемых параметров.  
  * @inner 
  * @param {number} performResultIndex Индекс результата выполнения.
  */
  const _requestAskableParams = (performResultIndex) => {
    WebAccess.Job.fireAll('ParamAsking', () => { 
      ShowAskableParams(WA.CR.ID, 'job', performResultIndex);
    });
  };

  /**
  * Отображает диалог выполнения ведущего задания и выполняет его.  
  * @inner 
  * @param {Array<object>} performResults Возможные результаты выполнения ведущего задания.
  */
  const _showLeaderJobPerformDialog = (performResults) => {
    if (performResults.length) {
      // Если один вариант выполнения, то отображать диалог нет смысла.
      if (performResults.length === 1) {
        _executeBeforeQueryParamsEvent(performResults[0].name, WA.CR.LeaderJobID).done((result) => {
          if (result.hasAskableParams) {
            // Есть запрашиваемые параметры.
            ShowAskableParams(WA.CR.LeaderJobID, 'job', 0);
          } else {
            // Нет запрашиваемых параметров.
            Core.jobs.performJob(WA.CR.LeaderJobID, 0);
          }
        });
      } else {
        const _clickOnResultParam = (dialog) => {
          //получить результат выполнения
          const selector = dialog.nextElementSibling.querySelector('.active');
          const performResultName = selector.getAttribute('id');
          const resIndex = selector.getAttribute('resIndex');

          _executeBeforeQueryParamsEvent(performResultName, WA.CR.LeaderJobID).done((result) => {
            if (result.hasAskableParams) {
              // Есть запрашиваемые параметры.
              ShowAskableParams(WA.CR.LeaderJobID, 'job', resIndex);
            } else {
              // Нет запрашиваемых параметров.
              Core.jobs.performJob(WA.CR.LeaderJobID, resIndex);
            }
          });
        };

        let dialog = new WebAccess.components.dialogs.BaseDialog();
        dialog.title = L('CONFIRMATION');
        dialog.html = g_ConfirmParam.Content;
        let index = 0;
        for (let jobPerformResult of performResults) {
          const button = {
            click() {
              _clickOnResultParam(this);
            },
            id: jobPerformResult.name,
            resIndex: index,
            text: jobPerformResult.title,
          };
          dialog.modalWindowButtons.push(button);
          index++;
        }

        //hack для нормального вычисления ширины диалога
        dialog.width = 860;
        dialog.isShowOkButton = false;
        dialog.isShowCancelButton = true;
        dialog.show();
        dialog.setWidth($('.ui-dialog-buttonset').last().width() + 50);
      }
    } else {
      // Нет результатов выполнения.
      _executeBeforeQueryParamsEvent('', WA.CR.LeaderJobID).done((result) => {
        if (result.hasAskableParams) {
          // Есть запрашиваемые параметры.
          ShowAskableParams(WA.CR.LeaderJobID, 'job');
        } else {
          // Нет запрашиваемых параметров.
          Core.jobs.performJob(WA.CR.LeaderJobID, 0);
        }
      });
    }
  }   
})(window.Core.toolBars.job);